import React from "react";
import {Route, Routes} from "react-router-dom";
import Home from "../pages/Home";
import NotFound from "../pages/NotFound";
import Department from "../pages/Department";
import Officer from "../pages/Officer";
import Statistics from "../pages/Statistics";
import Board from "../pages/Board";
import Post from "../pages/Post";
import Equipment from "../pages/Equipment";
import WorkOrder from "../pages/WorkOrder";
import Document from "../pages/Document";
import Permission from "../pages/Permission";
import Archive from "../pages/Archive";
import Manual from "../container/manual/Manual";
import Education from "../pages/Education";
import Suggestion from "../pages/Suggestion";
import ArchiveList from "../container/archive/ArchiveList";
import CreateFolder from "../container/archive/CreateFolder";
import UpdateFolder from "../container/archive/UpdateFolder";

const ManagerLevel = () => {
  return (
    <>
      <Routes>
        <Route path="Home/*" element={<Home />} />

        <Route path="Department/*" element={<Department />} />
        <Route path="Officer/*" element={<Officer />} />
        <Route path="Suggestion/*" element={<Suggestion />} />

        <Route path="Board/*" element={<Board />} />
        <Route path="Post/*" element={<Post />} />
        <Route path="Statistics/*" element={<Statistics />} />
        <Route path="Equipment/*" element={<Equipment />} />
        <Route path="WorkOrder/*" element={<WorkOrder />} />
        <Route path="Document/*" element={<Document />} />
        <Route path="Permission/*" element={<Permission />} />
        <Route path="Education/*" element={<Education />} />

        {/* <Route path="Archive/*" element={<Archive />} /> */}
        <Route path="Archive/" element={<ArchiveList />} />
        <Route path="Archive/:id" element={<ArchiveList />} />
        <Route path="Archive/Create/:id" element={<CreateFolder />} />
        <Route path="Archive/Edit/:id" element={<UpdateFolder />} />
        <Route path="Manual" element={<Manual />} />

        <Route path="*" element={<NotFound />} />
      </Routes>
    </>
  );
};

export default ManagerLevel;
